module.exports = require("./bs.js");